import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { TOMOS, TOMO_FEATURES } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';
const TOMOS_IMG = HERO_IMAGE_URL;
export function TomosSection() {
  return <section id="tomos" className="bg-sand py-12 sm:py-16" data-id="element-184" data-mp="1u2wqfa61bi5f">
      <div className="mx-auto max-w-5xl px-5" data-id="element-185" data-mp="1u4hkkyofsz2r">
        <div className="text-center" data-id="element-186" data-mp="xdfn31uiy86w">
          <SectionTag data-id="element-187" data-mp="xeh21henvetw">🏆 MegaPack 6 en 1</SectionTag>
          <h2 className="mt-4 font-display text-[1.8rem] font-semibold leading-tight text-charcoal sm:text-[2.6rem]" data-id="element-188" data-mp="11d7rd2cvxs6g">
            Wellness Digital Pro™ — MegaPack 6 en 1
          </h2>
          <p className="mt-2 font-sans text-sm font-medium text-charcoal/70 sm:text-base" data-id="element-189" data-mp="1bcotxawubpy7">
            6 tomos + 5 bonos — Del perfil a la agenda llena
          </p>
          <p className="mt-1.5 font-sans text-sm font-semibold tabular-nums text-gold-deep sm:text-base" data-id="element-190" data-mp="2hulol75jf0ua">
            350+ páginas — Todo resuelto
          </p>
        </div>

        <img src={TOMOS_IMG} alt="Los seis tomos del MegaPack Wellness Digital Pro junto a sus recursos digitales" width={1024} height={1024} loading="lazy" decoding="async" sizes="(max-width: 640px) 76vw, 400px" style={{
        aspectRatio: '1024 / 1024'
      }} className="mx-auto mt-7 block h-auto w-[76%] max-w-[380px] rounded-2xl border border-stone object-cover shadow-[0_28px_60px_-36px_rgba(28,27,25,0.4)]" data-id="element-191" data-mp="2qnp3k7ep3c6q" />

        <p className="mt-7 text-center text-[0.65rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-192" data-mp="22xcweyr9xjh7">
          Perfil → Contenido → Cierre → Planificación
        </p>

        <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-193" data-mp="1tz99pz4jygnt">
          {TOMOS.map((tomo, i) => <motion.article key={tomo.num} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="flex gap-3 rounded-xl border border-stone bg-ivory p-4 transition-colors hover:border-gold/50" data-id="element-194" data-mp="1oydavzz25kp9" data-mpi={i}>
              <span className="text-xl leading-none" aria-hidden data-id="element-195" data-mp="11davz35nnjg3">
                {tomo.emoji}
              </span>
              <div data-id="element-196" data-mp="15ewilg7zrc3h">
                <p className="font-sans text-[0.6rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-197" data-mp="1t2xlo9mei0bi">
                  {tomo.num}
                </p>
                <h3 className="mt-0.5 font-display text-lg font-semibold leading-tight text-charcoal" data-id="element-198" data-mp="1y0z1mloj5jir">
                  {tomo.title}
                </h3>
                <p className="mt-1 font-sans text-[0.8rem] leading-snug text-charcoal/70" data-id="element-199" data-mp="1ob5tjunljmj9">
                  {tomo.desc}
                </p>
              </div>
            </motion.article>)}
        </div>

        <div id="incluye" className="mt-8 rounded-2xl border border-stone bg-ivory p-5 sm:p-6" data-id="element-200" data-mp="2gt9z200f0p9h">
          <h3 className="text-center font-display text-xl font-semibold text-charcoal" data-id="element-201" data-mp="5c7xlb5r0qtx">
            Cada tomo incluye
          </h3>
          <ul className="mt-4 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-202" data-mp="c3pa8ezv2es">
            {TOMO_FEATURES.map(f => <li key={f} className="flex items-start gap-2" data-id="element-203" data-mp="f4x37pembahc">
                <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold-deep" aria-hidden data-id="element-204" data-mp="a5aunt9qiiev" />
                <span className="font-sans text-[0.82rem] leading-snug text-charcoal/75" data-id="element-205" data-mp="3ikkqijn16re7">{f}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}